
/* injects from baggage-loader */

'use strict';

import lockTemplate from '!!file-loader?name=templates/[name].[ext]!./lock.html';

/**
* Function that register the all routes for the lock module.
*
* @param {any} $q
* @param {any} $ocLazyLoad
* @param {any} routerHelper
*/
function routeConfig($q, $ocLazyLoad, routerHelper, navigationConstant) {
	'ngInject';

	/**
	* Route definition of the lock page.
	*/
	const indexNav = 6;
	const indexSubmenu = 4;
	const lockRoute = {
		state: navigationConstant.RESOURCES[indexNav].SUBMENUS[indexSubmenu].STATE,
		config: {
			url: navigationConstant.RESOURCES[indexNav].SUBMENUS[indexSubmenu].URL,
			templateUrl: lockTemplate,
			controller: 'LockController',
			controllerAs: 'lockvm',
			resolve: {
				lock: lockLazyLoading
			},
			data: {
				code: navigationConstant.RESOURCES[indexNav].SUBMENUS[indexSubmenu].CODE,
				login: true,
				pageTitle: navigationConstant.RESOURCES[indexNav].SUBMENUS[indexSubmenu].NAME,
				submenu: true
			},
		}
	}

	routerHelper.configureStates([lockRoute]);
}

/**
* Function for the lazyLoading configuration in the lock route.
*
* @param {any} $q
* @param {any} $ocLazyLoad
* @returns
*/
function lockLazyLoading($q, $ocLazyLoad) {
	'ngInject';

	const deferred = $q.defer();

	require.ensure([], require => {
		const lockModule = require('./lock.module');

		$ocLazyLoad.load({
			name: lockModule.default.name,
		});

		deferred.resolve(lockModule.default.controller);
	});

	return deferred.promise;
}

export default angular
.module('lock.routes', [])
.run(routeConfig);



// WEBPACK FOOTER //
// ./src/app/auth/components/lock/lock.routes.js